export enum DialogResultEnum {
  'Cancelled' = 'Cancelled',
  'ActionHappened' = 'ActionHappened',
}

export type DialogResult = 'ActionHappened' | 'Cancelled';
